const en = {
  lang_switch_label: 'Language',

  global_empty_state_title: 'Nothing here yet',
  global_empty_state_description: 'Add your first record to see it in this cockpit.',
  pagination_go_to_page: 'Go to page',
  pagination_items_per_page: 'Items per page',
  pagination_first_page: 'First page',
  pagination_previous_page: 'Previous page',
  pagination_next_page: 'Next page',
  pagination_last_page: 'Last page',

  login_welcome_back: 'Welcome back',
  login_subtitle: 'Sign in with your email and password.',
  login_email_label: 'Email',
  login_password_label: 'Password',
  login_button: 'Sign in',
  login_forgot_password: 'Forgot password?',
  login_reset_it: 'Reset it',
  login_error_user_not_found: 'Email and password do not match our records.',
  login_error_wrong_password: 'Incorrect password.',
  login_error_invalid_email: 'Invalid email address.',
  login_error_user_disabled: 'This account has been disabled.',
  login_error_login_failed: 'Sign-in failed. Please try again.',
  login_unexpected_error: 'Something went wrong. Please try again.',
  login_need_account: 'Need an account?',
  login_go_signup: 'Sign up',

  signup_create_account: 'Create your account',
  signup_get_started_description: 'Use the same email you will use in production.',
  signup_display_name_label: 'Display name (optional)',
  signup_email_label: 'Email',
  signup_password_label: 'Password',
  signup_confirm_password_label: 'Confirm password',
  signup_passwords_do_not_match: 'Passwords do not match.',
  signup_button: 'Create account',
  signup_already_have_account: 'Already have an account?',
  signup_login_link: 'Sign in',
  signup_email_already_in_use: 'That email is already registered.',
  signup_weak_password: 'Password is too weak. Use at least 6 characters.',
  signup_unexpected_error: 'Could not create your account. Please try again.',
  signup_firestore_hint:
    'Creates a Firestore document at users/{uid}. Ensure your security rules allow the signed-in user to write their own profile.',

  reset_password_title: 'Reset password',
  reset_password_subtitle: 'We will email you a link to choose a new password.',
  reset_password_email_label: 'Email',
  reset_password_send_button: 'Send reset link',
  reset_password_remembered_password: 'Remembered your password?',
  reset_password_back_to_login: 'Back to sign in',
  reset_password_success_message:
    'If an account exists for this email, you will receive a reset link shortly.',
  reset_password_error_unauthorized_domain:
    'This domain is not authorized for password reset. Add it under Firebase Console → Authentication → Settings → Authorized domains.',
  reset_password_error_no_account_found: 'No account found for this email.',
  reset_password_error_invalid_email: 'Please enter a valid email address.',
  reset_password_error_link_not_sent: 'Could not send the reset link. Please try again later.',
  reset_password_unexpected_error: 'Something went wrong. Please try again.',
  reset_password_action_url_hint:
    'Set the Firebase Auth action URL (continue URL) to /confirm-password on this origin so the link opens this screen.',

  reset_password_new_password_title: 'Choose a new password',
  reset_password_new_password_subtitle: 'Enter and confirm your new password.',
  reset_password_verifying: 'Verifying reset link…',
  reset_password_error_code_invalid: 'This reset link is invalid or has already been used.',
  reset_password_error_code_expired: 'This reset link has expired. Request a new one.',
  reset_password_new_password_label: 'New password',
  reset_password_confirm_password_label: 'Confirm new password',
  reset_password_reset_button: 'Update password',
  reset_password_success_reset: 'Password updated. Redirecting to sign in…',
  reset_password_error_passwords_mismatch: 'Passwords do not match.',
  reset_password_error_password_too_short: 'Use at least 6 characters.',
  reset_password_error_weak_password: 'Password is too weak. Try a stronger one.',
  reset_password_error_generic: 'Could not reset the password. Please try again.',
  reset_password_request_new_link: 'Request a new reset link',
} as const;

export type MessageKey = keyof typeof en;
export default en;
